import { useDebounce } from "hooks";
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";

type paginationProps = {
  activePage: number | undefined;
  setActivePage: (val: number) => void;
  totalPages: number | undefined;
};
export default function Pagination({
  activePage = 1,
  setActivePage,
  totalPages = 0,
}: paginationProps) {
  const debounce = useDebounce();
  const [ref, inView] = useInView();
  const max = totalPages;

  const handleGoToNextPage = () => {
    const canGoToNextPage = [activePage !== totalPages, inView].every(Boolean);
    debounce(() => {
      canGoToNextPage && setActivePage(activePage + 1);
    });
  };
  useEffect(handleGoToNextPage, [
    inView,
    activePage,
    totalPages,
    setActivePage,
  ]);
  if (max <= 1) return null;
  return <div ref={ref} className="w-full col-span-full h-10"></div>;
}
